import React, { useState } from "react";
import { Folder, X, Trash2, Check } from "lucide-react";
import { INK, INK_2, INK_3, LINE, BURGUNDY, BURGUNDY_TINT, BAD_INK } from "../../Bureau/bureauTokens";

const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

function labelJour(d) {
  return `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]}`;
}

// Modal centrée (pas un tiroir latéral façon maquette — ce pattern n'existe
// nulle part ailleurs dans l'app réelle) : détail d'une réservation de
// salle, ouverte au clic sur son bloc dans la grille (voir
// Planning.jsx#openRoomBooking). `booking` est l'objet déjà mappé par
// roomBookingsByDay (forme RdvBlock + salle/user/date bruts conservés).
function RoomBookingDetailModal({ booking, onCancel, onClose }) {
  const [cancelling, setCancelling] = useState(false);
  const { salle, user } = booking;
  const d = new Date(booking.date);

  const handleCancel = async () => {
    setCancelling(true);
    try {
      await onCancel();
    } finally {
      setCancelling(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[210] flex items-center justify-center p-4" style={{ background: "rgba(31,22,32,.45)" }} onClick={onClose}>
      <div
        className="w-full flex flex-col overflow-hidden"
        style={{ maxWidth: 440, background: "#fff", borderRadius: 18, boxShadow: "0 24px 60px rgba(20,14,24,.30)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3.5 px-5 py-4 flex-shrink-0" style={{ borderBottom: `1px solid ${LINE}` }}>
          <div
            className="flex items-center justify-center flex-shrink-0"
            style={{ width: 40, height: 40, borderRadius: 10, background: BURGUNDY_TINT, color: BURGUNDY }}
          >
            <Folder size={19} />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-sm font-semibold m-0 truncate" style={{ color: INK }}>
              {booking.client}
            </h2>
            <div className="text-[11px] mt-0.5 capitalize" style={{ color: INK_3 }}>
              {labelJour(d)} · {booking.time} · {booking.dur} min
            </div>
          </div>
          <button onClick={onClose} className="flex items-center justify-center flex-shrink-0" style={{ width: 32, height: 32, borderRadius: 8, border: `1px solid ${LINE}` }}>
            <X size={14} style={{ color: INK_2 }} />
          </button>
        </div>

        <div className="px-5 py-4">
          <div className="flex items-center gap-2 flex-wrap mb-3">
            {salle && (
              <span className="text-[11px] font-bold px-2.5 py-1" style={{ borderRadius: 20, background: `${salle.couleur}22`, color: salle.couleur }}>
                {salle.nom}
              </span>
            )}
            {salle && (
              <span className="text-[11px]" style={{ color: INK_3 }}>
                {salle.emplacement} · {salle.capacite} places
              </span>
            )}
          </div>
          {user && (
            <div className="flex items-center gap-2 text-xs" style={{ color: INK_2 }}>
              <span
                className="flex items-center justify-center text-white font-bold flex-shrink-0"
                style={{ width: 22, height: 22, borderRadius: "50%", background: salle?.couleur || INK_3, fontSize: 9.5 }}
              >
                {booking.collabInitials}
              </span>
              <span>
                <b>Réservé par</b> {user.name} {user.lastName}
              </span>
            </div>
          )}
        </div>

        <div className="flex items-center justify-between gap-2 px-5 py-3.5 flex-shrink-0" style={{ borderTop: `1px solid ${LINE}`, background: "#FAFAF8" }}>
          <button
            onClick={handleCancel}
            disabled={cancelling}
            className="flex items-center gap-1.5 px-4 py-2 text-xs font-semibold disabled:opacity-50"
            style={{ border: `1px solid ${BAD_INK}`, borderRadius: 10, color: BAD_INK, background: "#fff" }}
          >
            <Trash2 size={13} /> {cancelling ? "Annulation…" : "Annuler la réservation"}
          </button>
          <button
            onClick={onClose}
            className="flex items-center gap-1.5 px-4 py-2 text-xs font-semibold text-white"
            style={{ background: BURGUNDY, borderRadius: 10 }}
          >
            <Check size={13} /> Fermer
          </button>
        </div>
      </div>
    </div>
  );
}

export default RoomBookingDetailModal;
